import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarning = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18.7435 1.52295C20.7442 2.42631 22.265 5.14213 25.3067 10.5738L27.4809 14.4562C30.4047 19.6773 31.8667 22.2879 31.6222 24.4255C31.4089 26.2906 30.419 27.9793 28.8961 29.0767C27.1503 30.3346 24.1583 30.3346 18.1742 30.3346H13.8259C7.8418 30.3346 4.84977 30.3346 3.10409 29.0767C1.58106 27.9793 0.591283 26.2906 0.377935 24.4255C0.133398 22.2879 1.59533 19.6773 4.51917 14.4562L6.69331 10.5738C9.73503 5.14213 11.2559 2.42631 13.2566 1.52295C15.0007 0.735393 16.9993 0.735393 18.7435 1.52295ZM17.0001 12.0013C17.0001 11.449 16.5523 11.0013 16.0001 11.0013C15.4477 11.0013 15.0001 11.449 15.0001 12.0013V17.3346C15.0001 17.8869 15.4477 18.3346 16.0001 18.3346C16.5523 18.3346 17.0001 17.8869 17.0001 17.3346V12.0013ZM16.0001 20.3346C15.0795 20.3346 14.3334 21.0809 14.3334 22.0013C14.3334 22.9218 15.0795 23.6679 16.0001 23.6679C16.9205 23.6679 17.6667 22.9218 17.6667 22.0013C17.6667 21.0809 16.9205 20.3346 16.0001 20.3346Z",
		fill: "currentColor"
	})
});
export default SvgWarning;
